module.exports = {"title":"Area Charts","path":"area-charts","name":"area-charts","published":false}